<template>
    <el-dialog ref="innerElRef" v-if="isShowDialog" v-bind="$attrs">
        <template v-for="(_, name) in $slots" #[name]="scopedData">
            <slot :name="name" v-bind="scopedData"></slot>
        </template>
    </el-dialog>
    <el-drawer ref="innerElRef" v-else-if="isShowDrawer" v-bind="$attrs">
        <template v-for="(_, name) in $slots" #[name]="scopedData">
            <slot :name="name" v-bind="scopedData"></slot>
        </template>
    </el-drawer>
    <div v-else></div>
</template>
<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
const showType = ref('dialog');
const isShowDialog = computed(() => {
    return showType.value === 'dialog';
});
const isShowDrawer = computed(() => {
    return showType.value === 'drawer';
});

const innerElRef = ref();
const exposeObj = { isDrawer: isShowDrawer.value }; // 增加一个属性，用于外部判断当前是drawer还是dialog
onMounted(() => {
    if (!innerElRef.value) {
       return;
    }
    for (const key in innerElRef.value) {
        exposeObj[key] = innerElRef.value[key]; // 把内部实际组件的方法抛出，供外部调用
    }
    // defineExpose(exposeObj);
});

defineExpose(exposeObj);
</script>
